import * as React from 'react';
import { HowItWorkLayout, HowItWorkItem } from '../../../components/HowItWork';
import { useApplicationContext } from '../../../utils/applicationContext';
import { getHowItWorkProps } from './constants';

export const HowItWorkContainer: React.FC = () => {
  const { custom } = useApplicationContext();
  const { title, className, items } = getHowItWorkProps(custom.pageType);

  return (
    <HowItWorkLayout title={title} className={className}>
      {items.map(item => (
        <HowItWorkItem key={item.title} {...item} />
      ))}
    </HowItWorkLayout>
  );
};
